import { useState } from 'react';
import AirItemTypeService from './AirItemTypeService';

function useManageAirItemType() {
    const [airItemTypes, setAirItemTypes] = useState([]);
    const [uniqueCategories, setUniqueCategories] = useState([]);
    const [uniqueTypes, setUniqueTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshAirItemTypes = async (filters = {}) => {
        setIsLoading(true);
        try {
            const response = await AirItemTypeService.getAirItemTypes(filters);
            const data = response.data.data;
            setAirItemTypes(Array.isArray(data) ? data : []);
            setError(null);
        } catch (err) {
            console.log(err)
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const refreshUniqueCategories = async () => {
        try {
            const response = await AirItemTypeService.getUniqueCategories();
            const data = response.data.data;
            setUniqueCategories(Array.isArray(data) ? data : []);
        } catch (err) {
            console.log('Error fetching unique categories:', err);
        }
    };

    const refreshUniqueTypes = async () => {
        try {
            const response = await AirItemTypeService.getUniqueTypes();
            const data = response.data.data;
            setUniqueTypes(Array.isArray(data) ? data : []);
        } catch (err) {
            console.log('Error fetching unique types:', err);
        }
    };

    const addAirItemType = async (airItemTypeData) => {
        let result = true
        setIsLoading(true);
        try {
            await AirItemTypeService.addAirItemType(airItemTypeData);
            refreshAirItemTypes();
        } catch (err) {
            result = false
            setError(err.response.data.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result
    };

    const editAirItemType = async (airItemTypeId, updatedData) => {
        setIsLoading(true);
        try {
            await AirItemTypeService.editAirItemType(airItemTypeId, updatedData);
            refreshAirItemTypes();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const deleteAirItemType = async (airItemTypeId) => {
        setIsLoading(true);
        try {
            await AirItemTypeService.deleteAirItemType(airItemTypeId);
            refreshAirItemTypes();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        airItemTypes,
        uniqueCategories,
        uniqueTypes,
        isLoading,
        error,
        addAirItemType,
        editAirItemType,
        deleteAirItemType,
        refreshAirItemTypes,
        refreshUniqueCategories,
        refreshUniqueTypes
    };
}

export default useManageAirItemType;
